import { watch } from 'vue'
import { useRoute } from 'vue-router'
import { useLenis } from 'lenis/vue'

/**
 * 換頁後回到頂端。
 *
 * vue-router 的 scrollBehavior 用的是 `window.scrollTo`，但 Lenis 接管整頁捲動後會把它
 * 當成一次捲動事件、以動畫補間過去（實測：呼叫當下仍停在 67，約 1 秒後才到 0）。這段
 * 期間新頁面正在載入資料、高度會變，使用者也可能碰到畫面，動畫一旦被打斷就停在半途，
 * 症狀就是「換頁後畫面不在最上面」。
 *
 * 改用 Lenis 自己的 `immediate` 直接定位，不留動畫時間給外在因素打斷。
 */
export const useRouteScrollReset = () => {
  const route = useRoute()
  const lenis = useLenis()

  watch(
    () => route.fullPath,
    () => lenis.value?.scrollTo(0, { immediate: true })
  )
}
